module.exports = __webpack_public_path__ + "static/media/sad.08b34fc8.png";